<template>
    <div id="app">
        <h1>Hermes Tester</h1>
        <Authentication />
        <hr>
        <RouterView />
    </div>
</template>

<script>
import Authentication from '@/components/Authentication.vue';

export default {
    name: 'App',

    components: {
        Authentication,
    },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

h1 {
  margin: 0;
  padding: 0;
}

hr {
  color: #d8d8d8;
}
</style>
